export default "__VITE_ASSET__274Ix_G7__"